import { selector } from 'recoil'
import { IProjectRole } from './projectRoles.types'
import { projectRolesAtom } from './projectRoles.atom'

const projectRolesMap = selector({
  key: 'selectors/project-roles-map',
  get: ({ get }): Record<IProjectRole['id'], IProjectRole> => {
    const state = get(projectRolesAtom)

    return state.items.reduce((acc, val) => ({ ...acc, [val.id]: val}), {})
  },
})

const projectRolesSelectors = { projectRolesMap }
export default projectRolesSelectors
